import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRecintos } from '../services/api';

export default function Recintos() {
  const navigate              = useNavigate();
  const [recintos, setRecintos] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    setCargando(true);
    getRecintos()
      .then(data => { if (Array.isArray(data)) setRecintos(data); })
      .catch(() => {})
      .finally(() => setCargando(false));
  }, []);

  return (
    <div style={styles.pagina}>

      <div style={styles.header}>
        <div style={styles.headerInner}>
          <div>
            <div style={styles.titulo}>Recintos deportivos</div>
            <div style={styles.sub}>
              {cargando ? 'Cargando...' : `${recintos.length} recintos registrados`}
            </div>
          </div>
          <button style={styles.btnRegistrar} onClick={() => navigate('/registro-recinto')}>
            ¿Tienes un recinto? Regístralo →
          </button>
        </div>
      </div>

      <div style={styles.contenido}>
        {cargando ? (
          <div style={styles.cargando}>Cargando recintos...</div>
        ) : recintos.length === 0 ? (
          <div style={styles.vacio}>
            <div style={styles.vacioIcono}>🏟️</div>
            <div style={styles.vacioTitulo}>Sin recintos registrados aún</div>
            <div style={styles.vacioSub}>
              Sé el primero en registrar tu recinto en TuRival.
            </div>
            <button style={styles.btnRegistrarGrande} onClick={() => navigate('/registro-recinto')}>
              Registrar mi recinto →
            </button>
          </div>
        ) : (
          <>
            {recintos.map((r, i) => (
              <div key={r.id || i} style={styles.recintoCard}>
                <div style={styles.recintoHeader}>
                  <div style={styles.recintoIcono}>🏟️</div>
                  <div style={styles.recintoInfo}>
                    <div style={styles.recintoNombre}>{r.nombre}</div>
                    <div style={styles.recintoDireccion}>📍 {r.direccion}</div>
                    <div style={styles.recintoZona}>{r.zona}</div>
                  </div>
                </div>

                {r.apertura && r.cierre && (
                  <div style={styles.horarioRow}>
                    <span style={styles.horarioLabel}>Horario:</span>
                    <span style={styles.horarioVal}>{r.apertura} — {r.cierre}</span>
                  </div>
                )}

                {r.dias_activos?.length > 0 && (
                  <div style={styles.diasRow}>
                    {r.dias_activos.map(d => (
                      <span key={d} style={styles.diaChip}>{d}</span>
                    ))}
                  </div>
                )}

                <div style={styles.recintoFooter}>
                  <button
                    style={styles.btnVerCalendario}
                    onClick={() => navigate('/app/matchmaking')}
                  >
                    Buscar partido en este recinto →
                  </button>
                </div>
              </div>
            ))}

            <div style={styles.registrarCard} onClick={() => navigate('/registro-recinto')}>
              <div style={styles.registrarIcono}>+</div>
              <div style={styles.registrarTitulo}>Registra tu recinto en TuRival</div>
              <div style={styles.registrarSub}>
                Expón tu calendario, recibe reservas y llega a
                cientos de equipos activos en tu zona. Es gratis.
              </div>
              <div style={styles.registrarBtn}>Registrar mi recinto →</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  pagina: { minHeight: '100vh', background: '#F4F6FA' },
  header: {
    background: '#0D1117', padding: '24px 32px',
    borderBottom: '1px solid rgba(255,255,255,0.06)', marginBottom: 24,
  },
  headerInner: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 32, fontWeight: 800, color: 'white', marginBottom: 4,
  },
  sub: { fontSize: 13, color: 'rgba(255,255,255,0.4)', fontFamily: "'Barlow', sans-serif" },
  btnRegistrar: {
    background: '#FF6B1A', color: 'white', border: 'none',
    borderRadius: 10, padding: '10px 18px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 15, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap',
  },
  contenido: {
    padding: '0 32px 32px',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
    gap: 16,
  },
  cargando: {
    gridColumn: '1 / -1', textAlign: 'center', padding: '60px',
    fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif",
  },
  vacio: {
    gridColumn: '1 / -1', textAlign: 'center', padding: '60px 20px',
  },
  vacioIcono: { fontSize: 56, marginBottom: 16 },
  vacioTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 8,
  },
  vacioSub: {
    fontSize: 14, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif",
    maxWidth: 400, margin: '0 auto 24px', lineHeight: 1.6,
  },
  btnRegistrarGrande: {
    background: '#FF6B1A', color: 'white', border: 'none',
    borderRadius: 12, padding: '13px 28px',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, cursor: 'pointer',
  },
  recintoCard: {
    background: 'white', border: '1px solid #E8ECF4',
    borderRadius: 16, padding: '20px',
  },
  recintoHeader: { display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 14 },
  recintoIcono: { fontSize: 32, flexShrink: 0 },
  recintoInfo: { flex: 1 },
  recintoNombre: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 20, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  recintoDireccion: {
    fontSize: 12, color: '#6B7280', fontFamily: "'Barlow', sans-serif", marginBottom: 3,
  },
  recintoZona: { fontSize: 12, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  horarioRow: { marginBottom: 10, fontSize: 13, fontFamily: "'Barlow', sans-serif" },
  horarioLabel: { color: '#9BA5B7', marginRight: 6 },
  horarioVal: { color: '#141922', fontWeight: 600 },
  diasRow: { display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 14 },
  diaChip: {
    background: '#EFF5FF', border: '1px solid #DBEAFE',
    borderRadius: 6, padding: '3px 9px',
    fontSize: 11, fontWeight: 600, color: '#1e40af',
    fontFamily: "'Barlow', sans-serif",
  },
  recintoFooter: { borderTop: '1px solid #F4F6FA', paddingTop: 14 },
  btnVerCalendario: {
    width: '100%', padding: '10px',
    background: '#F4F6FA', border: '1px solid #E8ECF4',
    borderRadius: 10,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 14, fontWeight: 700, color: '#4A5568', cursor: 'pointer',
  },
  registrarCard: {
    background: '#0D1117', border: '2px dashed rgba(255,255,255,0.1)',
    borderRadius: 16, padding: '32px 20px', textAlign: 'center',
    cursor: 'pointer', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', gap: 10,
  },
  registrarIcono: {
    width: 48, height: 48, borderRadius: '50%',
    background: 'rgba(255,107,26,0.15)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 24, color: '#FF6B1A', fontWeight: 700,
  },
  registrarTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: 'white',
  },
  registrarSub: {
    fontSize: 12, color: 'rgba(255,255,255,0.35)',
    fontFamily: "'Barlow', sans-serif", lineHeight: 1.5, maxWidth: 280,
  },
  registrarBtn: {
    fontSize: 13, fontWeight: 700, color: '#FF6B1A',
    fontFamily: "'Barlow Condensed', sans-serif", marginTop: 4,
  },
};